import React from "react";
import { Process } from "@italymondo/core-ui";
import { useStaticOurProcessQuery } from "./query";

export function OurProcess(): React.ReactElement | null {
  const data = useStaticOurProcessQuery();

  if (!data) {
    return null;
  }

  return (
    <Process
      ctaLink={data.contactPage[0]?.process?.cta}
      description={data.contactPage[0].process.description || ""}
      media={data.contactPage[0].processMedia[0]}
      mediaPlacement={data.contactPage[0].processMediaPlacement}
      sectionName={data.contactPage[0].processSectionName || ""}
      steps={data.contactPage[0].process.steps.map((step) => ({
        description: step.description,
        shadowHeader: step.step,
        title: step.name,
      }))}
      title={data.contactPage[0]?.process.title || ""}
    />
  );
}
